export default function cleanNullInputs (obj) {
    return Object.keys(obj)
        .filter(k => obj[k] != null) // Remove undef. and null.
        .reduce(
            (newObj, k) =>
                typeof obj[k] === 'object'
                    ? {...newObj, [k]: cleanNullInputs(obj[k])} // Recurse.
                    : {...newObj, [k]: obj[k]}, // Copy value.
            {}
        )
}
